const COLOR_MAP = {
  DrugDiseaseContraIndications: {
    Contraindication: 'red-dot',
    'Severe Warning': 'orange-dot',
    'Moderate Warning': 'yellow-dot',
  },
  DrugDrugInteractions: {
    'Contraindicated Drug Combination': 'red-dot',
    'Severe Interaction': 'orange-dot',
    'Moderate Interaction': 'yellow-dot',
    'Undetermined Severity - Alternative Therapy Interaction': 'gray-dot',
  },
  SideEffects: { Severe: 'red-dot', 'Less Severe': 'yellow-dot' },
  PregnancyPrecautions: {
    Contraindicated: 'red-dot',
    'Known or Theoretical Risk': 'orange-dot',
    'Requires a Risk/Benefit Assessment': 'yellow-dot',
    'No Known Fetal/Neonatal Risk': 'green-dot',
  },
  PediatricPrecautions: {
    Contraindication: 'red-dot',
    'Severe Precaution': 'orange-dot',
    'Management or Monitoring Precaution': 'yellow-dot',
  },
  LactationPrecautions: {
    'Absolute Contraindication': 'red-dot',
    Precaution: 'orange-dot',
    'No Known Risk': 'green-dot',
  },
  GeriatricPrecautions: {
    Contraindication: 'red-dot',
    'Severe Precaution': 'orange-dot',
    'Management or Monitoring Precaution': 'yellow-dot',
  },
};

export default COLOR_MAP;
